import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import patchTransitionProposalPerformanceVisibility, { patchTransitionProposalPerformanceVisibilityKeyMaker, } from "../requests/patchTransitionProposalPerformance";
import { getTransitionProposalPerformanceVisibilityKeyMaker } from "./useGetTransitionProposalPerformanceVisibility";
const IDEMPOTENCY_DESCRIPTOR = "patch-transition-proposal-performance";
const usePatchTransitionProposalPerformanceVisibility = (config) => {
    const queryClient = useQueryClient();
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const mutation = useMutation({
        mutationFn: async ({ body, transitionProposalId }) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return patchTransitionProposalPerformanceVisibility(transitionProposalId, body, idempotencyKey, config);
        },
        onMutate: async ({ body, transitionProposalId }) => {
            // Cancel any outgoing refetches
            await queryClient.cancelQueries({
                queryKey: getTransitionProposalPerformanceVisibilityKeyMaker(transitionProposalId),
            });
            // Snapshot the previous value
            const previousData = queryClient.getQueryData(getTransitionProposalPerformanceVisibilityKeyMaker(transitionProposalId));
            // Optimistically update to the new value
            queryClient.setQueryData(getTransitionProposalPerformanceVisibilityKeyMaker(transitionProposalId), (oldData) => {
                if (!oldData?.data) {
                    return oldData;
                }
                const { portfolioView, metrics, visible } = body;
                // Update the visibility state for the specified performance metrics
                const updatedData = {
                    ...oldData,
                    data: {
                        ...oldData.data,
                        [portfolioView]: {
                            ...oldData.data[portfolioView],
                            // Update each metric in the metrics array with the new visibility
                            ...metrics.reduce((acc, metric) => ({
                                ...acc,
                                [metric]: visible,
                            }), {}),
                        },
                    },
                };
                return updatedData;
            });
            return { previousData };
        },
        onError: (_error, { transitionProposalId }, context) => {
            // If mutation fails, rollback to the previous value
            if (context?.previousData) {
                queryClient.setQueryData(getTransitionProposalPerformanceVisibilityKeyMaker(transitionProposalId), context.previousData);
            }
        },
        onSuccess: (_, { transitionProposalId }) => {
            queryClient.invalidateQueries({
                queryKey: getTransitionProposalPerformanceVisibilityKeyMaker(transitionProposalId),
            });
            queryClient.invalidateQueries({
                queryKey: patchTransitionProposalPerformanceVisibilityKeyMaker(transitionProposalId),
            });
        },
        onSettled: () => {
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation;
};
export default usePatchTransitionProposalPerformanceVisibility;
//# sourceMappingURL=usePatchTransitionProposalPerformanceVisibility.js.map